import { render, staticRenderFns } from "./hotSaleProducts.vue?vue&type=template&id=5909b4a8&scoped=true&"
import script from "./hotSaleProducts.vue?vue&type=script&lang=js&"
export * from "./hotSaleProducts.vue?vue&type=script&lang=js&"
import style0 from "./hotSaleProducts.vue?vue&type=style&index=0&id=5909b4a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5909b4a8",
  null
  
)

export default component.exports